export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  Assignment = 'Assignment',
  Website = 'Website',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
